import cn from 'clsx'

import React from 'react'
export type Props = {
  className?: string
  children?: React.ReactNode
}
export const Header = (props: Props): React.ReactElement<'header'> => {
  const { className, children } = props
  return <header className={cn('Panel_Header', className)}>{children}</header>
}
export default Header
